export const updateNested = (currentState, path, updatedState) => {
  const newState = { ...currentState };

  let ref = newState;
  for (let i = 0; i < path.length - 1; i++) {
    ref[path[i]] = { ...ref[path[i]] };
    ref = ref[path[i]];
  }

  const lastKey = path[path.length - 1];

  ref[lastKey] = {
    ...ref[lastKey],
    ...updatedState
  };

  return newState;
};

export const deleteNested = (currentState, path, keyToDelete = null) => {
  const newState = { ...currentState };

  let ref = newState;
  for (let i = 0; i < path.length - 1; i++) {
    ref[path[i]] = { ...ref[path[i]] };
    ref = ref[path[i]];
  }

  const lastKey = path[path.length - 1];

  if (keyToDelete) {
    if (ref[lastKey]) {
      const updatedSubState = { ...ref[lastKey] };
      delete updatedSubState[keyToDelete];

      ref[lastKey] = updatedSubState;
    }
  } else {
    delete ref[lastKey];
  }

  return newState;
};
